import type { FC } from 'react';

import type { OfferReadyContentProps } from '../AuthManager';
import { ReadyContent } from '../ReadyContent';
import { markAuthGateStart } from './authGateTelemetry';

type AuthGateReadyContentProps = OfferReadyContentProps & { loadingPage: FC };

export const AuthGateReadyContent: FC<AuthGateReadyContentProps> = (props) => {
    markAuthGateStart();
    return <ReadyContent {...props} />;
};
